import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routes } from '@platform/core/lib/routes';
import { KeyLine } from '../keyline/KeyLine';
import { valueOf } from '../valueOf';
import type { IRecordHeaderProps } from './IRecordHeaderProps';
import { recordCode } from './recordCode';
import { useTitlePlaceholder } from './useTitlePlaceholder';
import { useTypeLabel } from './useTypeLabel';

/**
 * Шапка запису (UIUX forms/form-structure, field-types/title; прототип v4): номер у рамці (mono, «101» — без префікса типу; у чернетки —
 * наступний номер типу або «…») · назва типу (акцент 600, веде до таблиці) · «✦ ШІ», якщо запис написав асистент; назва — поле 22px/600 без рамки (рамка з'являється при наведенні, фокус — акцент),
 * однорядкове (Enter не переносить), але довга назва переноситься, а не обрізається; у режимі перегляду лише для читання; під нею —
 * ключовий рядок.
 */
export function RecordHeader({ ws, moduleKey, listLabel, rt, record, editor, canEdit, openFull, isNew = false }: IRecordHeaderProps) {
  const { t } = useTranslation();
  const singular = useTypeLabel(rt, record, editor.draft);
  const title = String(valueOf(record, editor.draft, 'title') ?? '');
  const aiMade = record.ext?.['aiAuthored'] === true;
  const placeholder = useTitlePlaceholder(rt);
  return (
    <div className="rec-head">
      <div className="rec-head__main">
        <div className="rec-head__ident">
          <span className="rec-code" title={isNew ? t('recordPage.draft.codeTitle') : record.display}>{isNew && !(record.code > 0) ? '…' : recordCode(record.display, record.code)}</span>
          <Link className="rec-type" to={routes.list(moduleKey, rt.key)} title={t('recordPage.openType', { module: listLabel })}>{singular}</Link>
          {aiMade && <span className="rec-ai" title={t('recordPage.aiBadgeTitle')}>{t('recordPage.aiBadge')}</span>}
        </div>
        <textarea className="rec-title" rows={1} value={title} readOnly={!canEdit} aria-label={t('recordPage.titleLabel')} aria-invalid={Boolean(editor.fieldErrors['title']) || undefined}
          placeholder={placeholder} onChange={(e) => editor.setField('title', e.target.value.replace(/\n/g, ' '))}
          onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }} />
        <KeyLine ws={ws} rt={rt} record={record} editor={editor} readOnly={!canEdit} />
      </div>
      {openFull && <Link className="rec-head__open" to={openFull}>{t('recordPage.open')}</Link>}
    </div>
  );
}
